var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseField',{attrs:{"icon":_vm.icon,"description":_vm.description,"error-message":_vm.errorMessage,"has-error":_vm.hasError,"portal-target":_vm.portalTarget}})
}
var staticRenderFns = []

export { render, staticRenderFns }